export default {
    RX_ORDER_NEW: 'rx_delivery_new_order',
    RX_ORDER_PROCESSING: 'rx_delivery_processing_order',
    RX_ORDER_COMPLETE: 'rx_delivery_complete_order',
    RX_ORDER_COMPLETE_TRACKING: 'rx_delivery_complete_order_tracking',
    RX_ORDER_CANCELED: 'rx_delivery_canceled_order',
    RX_ORDER_PAST: 'rx_order_past',
}